import React from 'react';
import AppIcon from '../../../components/AppIcon';
import { formatCurrency } from '../../../utils/currency';

const AccountSummaryCards = ({ accounts, company }) => {
  const calculateSummary = () => {
    const summary = {
      totalAssets: 0,
      totalLiabilities: 0,
      totalEquity: 0,
      totalIncome: 0,
      totalExpenses: 0,
      activeAccounts: 0
    };

    const processAccount = (account) => {
      if (account?.isActive) {
        summary.activeAccounts++;
        
        switch (account?.type) {
          case 'Asset':
            summary.totalAssets += account?.balance;
            break;
          case 'Liability':
            summary.totalLiabilities += account?.balance;
            break;
          case 'Equity':
            summary.totalEquity += account?.balance;
            break;
          case 'Income':
            summary.totalIncome += account?.balance;
            break;
          case 'Expense':
            summary.totalExpenses += account?.balance;
            break;
        }
      }

      if (account?.children) {
        account?.children?.forEach(processAccount);
      }
    };

    accounts?.forEach(processAccount);
    return summary;
  };

  const summary = calculateSummary();

  const formatAmount = (amount) => {
    if (company?.currency) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: company.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    }
    return formatCurrency(amount);
  };

  const cards = [
    {
      label: 'Total Assets',
      value: summary?.totalAssets,
      icon: 'TrendingUp',
      color: 'success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Total Liabilities',
      value: summary?.totalLiabilities,
      icon: 'TrendingDown',
      color: 'warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Total Equity',
      value: summary?.totalEquity,
      icon: 'PieChart',
      color: 'accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Total Income',
      value: summary?.totalIncome,
      icon: 'DollarSign',
      color: 'primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Total Expenses',
      value: summary?.totalExpenses,
      icon: 'CreditCard',
      color: 'error',
      bgColor: 'bg-error/10'
    },
    {
      label: 'Active Accounts',
      value: summary?.activeAccounts,
      icon: 'Activity',
      color: 'primary',
      bgColor: 'bg-primary/10',
      isCount: true
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 md:gap-6">
      {cards?.map((card, index) => (
        <div
          key={index}
          className="bg-card rounded-lg shadow-sm border border-border p-4 md:p-6 hover-lift transition-smooth"
        >
          <div className="flex items-start justify-between mb-3 md:mb-4">
            <div className={`w-10 h-10 md:w-12 md:h-12 rounded-md flex items-center justify-center ${card?.bgColor}`}>
              <AppIcon 
                name={card?.icon} 
                size={20} 
                color={`var(--color-${card?.color})`} 
              />
            </div>
          </div>
          <p className="caption text-muted-foreground mb-1 md:mb-2">
            {card?.label}
          </p>
          <p className="font-heading font-semibold text-xl md:text-2xl lg:text-3xl text-foreground">
            {card?.isCount ? card?.value : formatAmount(card?.value)}
          </p>
        </div>
      ))}
    </div>
  );
};

export default AccountSummaryCards;